import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BaseTable from 'components/ui/tables/BaseTable';
import { useFormik } from 'formik';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';
import useFormSubmit from 'hooks/useFormSubmit';

const StaffTargetModal = (props) => {
  const { open, setOpen } = props;
  const [refetch, setRefetch] = useState(false);
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();
  const handleClose = () => {
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      user_id: null,
    },
    onSubmit: async (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        '/admin/crm-target',
        "Hodim muvaffaqiyatli bog'landi",
        null,
        false,
        handleFinishRequest
      );
    },
  });
  const handleFinishRequest = () => {
    setRefetch(true);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[75vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-2 !bg-[#CDCDCDC7]'
      >
        <span className='mr-4'>{t('common.button.targetStaffs')}</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <div className='w-full mb-4 flex items-center justify-between gap-3'>
            <div className='grow'>
              <FormSelectField
                delay={0}
                label={t('common.fields.staff')}
                path='/dictionary/active-staffs'
                fieldName='user_id'
                formik={formik}
              />
            </div>

            <div>
              <div className='[&>div]:!mt-0 [&>div]:!text-right'>
                <FormActionButtons
                  delay={0}
                  duration={0}
                  isSubmitting={isSubmitting}
                  disabled={!formik?.values?.user_id}
                  formType='dialog'
                  saveTitle={t('common.button.connect')}
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </div>
            </div>
          </div>
        </form>
        <div className='component-table-wrapper h-[calc(100vh-235px)]'>
          <BaseTable
            emitRefetch={{ refetch, setRefetch }}
            dataPath='admin/crm-target/index'
            tableName='admin/crm-target/index'
            headCells={[
              { code: 'id', label: '#' },
              { code: 'user', label: t('common.table.staff') },
            ]}
            columns={[
              { code: 'id' },
              { code: 'user', type: 'nested', childStr: 'name' },
            ]}
            actionDelete={{
              link: 'admin/crm-target/delete',
              method: 'post',
              paramId: true,
              key: 'id',
            }}
            size='small'
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(StaffTargetModal);
